import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-night text-white" data-id="element-208" data-mp="uyksaz99jqmd">
      <a href="#contenido" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-night" data-id="element-209" data-mp="uwgpylr0izo7">
        Saltar al contenido
      </a>
      <Header transparentAtTop={pathname === '/'} data-id="element-210" data-mp="gzuutiij7oxh" />
      <main id="contenido" className="flex-1" data-id="element-211" data-mp="c7a4ws2qxvz8">
        <Outlet data-id="element-212" data-mp="c6ihw5n7t6kk" />
      </main>
      <Footer data-id="element-213" data-mp="3knmyoabs97nz" />
    </div>;
}